import { useQuery } from "@tanstack/react-query";
import { getStates } from "../../service/query/auth";

export const useGetStates= (id) => {
  const states = useQuery({
    queryKey:["get_all_states", id],
    queryFn:async()=> getStates({id}),
    enabled: !!id,
    staleTime: 0,
  },

);
  return {data:states?.data?.data,  ...states,}
};